import React, {useState} from "react";
import {getData,setLocalStorage,getTrans} from '../common'
import config from "../common/config";
import {Consume} from '../Context/Consumer'
import {TransContext} from '../Context'

const Cookies = (props) => {
	const [cookiePopup, setCookiePopup] = useState(true);
    const [accecptCookie,setAcceptCookie] = useState(false);
	let trans = props.TransData.data;

	

    let setGdpr = (paramsObj, cb, err) => {
        let apiParams = {
          endPoint: config.WebConfig[config.APINames.CookieAccecptUrl]
            ? config.APIBASEPATH +
            config.WebConfig[config.APINames.CookieAccecptUrl]
            : config.APIBASEPATH + "cookiepolicy/user/accept",
          type: "POST",
          name: config.APINames.CookieAccecptUrl,
          params: paramsObj,
        };
        getData(
          apiParams,
          (resp) => {
            setAcceptCookie(resp.Data);
            if (cb) {
              cb(resp.Data);
            }
          },
          (error) => {
            if (err) {
              err(error);
            }
          }
        );
      };

	let acceptCookieHanlder = () => {
        setGdpr({},()=>{});
        setLocalStorage('setGDPR' , true)
		setCookiePopup(!cookiePopup);
	};

    

	return cookiePopup ? (
		<div className={`si-cookies__wrap si-fade ${cookiePopup ? 'in' : "out"}`}>
			<div className='si-cookies__container'>
				<div className='si-main__container--fluid'>
					<div className='si-main__container'>
						<div className='si-cookies__box'>
							<div className='si-cookies__lft'>
								<div className='si-cookies__title'>
									<span>
										{getTrans(trans,"cookie_title","We use cookies on this site to enhance your user experience")}
									</span>
								</div>
								<div className='si-cookies__discription'>
									<span>{getTrans(trans,"cookie_info","By clicking any link on this page you are giving your consent for us to set cookies.")}
										<a href=''>{getTrans(trans,"cookie_more_info","No, give me more info")}</a>
									</span>
								</div>
							</div>
							<div className='si-cookies__rgt'>
								<div className='si-cookies__cta'>
									<div className='si-btn si-btn__link'>
										<span>{getTrans(trans,"cookies_settings","Cookies Settings")}</span>
									</div>
									<div
										className='si-btn si-btn__primary'
										onClick={() => {
											acceptCookieHanlder();
										}}
									>
										<span>{getTrans(trans,"i_accept_all_cookies","I accept All Cookies")}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	) : null;
};

export default Consume(Cookies,[TransContext]);
